module.exports = __webpack_public_path__ + "img/info-icon.e63d9274.svg";